import { render, staticRenderFns } from "./multi.vue?vue&type=template&id=5982c171"
import script from "./multi.vue?vue&type=script&lang=js"
export * from "./multi.vue?vue&type=script&lang=js"
import style0 from "./multi.vue?vue&type=style&index=0&id=5982c171&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports